'use strict';

var Css = require("bs-css-emotion/lib/js/src/Css.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");

var error = Curry._1(Css.style, {
      hd: Css.color(Css.hex("ff8787")),
      tl: {
        hd: Css.fontSize(Css.px(20)),
        tl: /* [] */0
      }
    });

function $$Error(Props) {
  return React.createElement("div", {
              className: error
            }, "There was an error.");
}

function makeProps(prim0, prim1) {
  var tmp = {};
  if (prim0 !== undefined) {
    tmp.key = prim0;
  }
  return tmp;
}

var make = $$Error;

exports.makeProps = makeProps;
exports.make = make;
/* error Not a pure module */
